<template>
  <v-app id="inspire">
    <v-app-bar
        app
        color="primary"
        :clipped-left="true"
        dark
        class="d-print-none"
    >
      <v-toolbar-title class="mr-3">
        <v-text-field
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Поиск"
            class="hidden-sm-and-down"
            v-model="search"
            @keyup.enter="onSearchKeyupEnter"
        />
      </v-toolbar-title>

      <template v-if="$store.getters.appIsInitialized">
        {{ $store.getters.appLogin.name }}
        <span class="mx-3">|</span>
        {{ $store.getters.appActiveClient.name }}
        <span class="mx-3">|</span>
      </template>
      {{ $store.getters.layoutPageTitle }}
      <v-spacer/>
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-badge
              :content="notificationCount"
              :value="notificationCount > 0"
              color="red"
              overlap
              class="mr-4"
          >
            <v-btn icon v-bind="attrs" v-on="on" @click="onCreateNotificationClicked">
              <v-icon>mdi-facebook-messenger</v-icon>
            </v-btn>
          </v-badge>
        </template>
      </v-menu>
      <v-dialog v-model="showNotificationDialog" max-width="800px" persistent scrollable>
        <v-card style="height: 500px; display: flex; flex-direction: column;">
          <v-card-title class="blue--text text--darken-2" style="flex: 0 0 auto;">
            📬 Сообщения
            <v-spacer></v-spacer>
            <v-btn icon @click="showNotificationDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider style="flex: 0 0 auto;"></v-divider>

          <v-btn
              color="primary"
              block
              small
              class="mb-4"
              @click="NewChat()"
          >
            <v-icon left>mdi-message-plus</v-icon> Новый чат
          </v-btn>


          <v-card-text
              class="pa-0"
              style="flex: 1 1 auto; display: flex; height: 100%; overflow: hidden;"
          >
            <v-row no-gutters style="flex: 1 1 auto; display: flex; height: 100%; width: 100%; margin: 0;">
              <!-- User List (Scrollable) -->
              <v-col
                  cols="4"
                  class="pa-4 grey lighten-4"
                  style="border-right: 1px solid #e0e0e0; overflow-y: auto; height: 100%;"
              >
                <v-list dense nav shaped>
                  <v-list-item
                      v-for="chat in chats"
                      :key="chat.ParticipantId"
                      @click="selectUser(chat)"
                      :class="{ 'blue lighten-4': selectedChat && selectedChat.ParticipantId === chat.ParticipantId }"
                      class="rounded-lg"
                  >
                    <v-badge
                        v-if="chat.IsUnread"
                        dot
                        color="red"
                        overlap
                    >
                      <template #badge>
                        <span></span>
                      </template>
                      <v-list-item-avatar>
                        <v-icon color="primary">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                    </v-badge>
                    <v-list-item-avatar v-else>
                      <v-icon color="primary">mdi-account-circle</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>{{ chat.ParticipantName }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <!-- Chat Area -->
              <v-col
                  cols="8"
                  class="pa-4 d-flex flex-column"
                  style="background-color: #fafafa; height: 100%;"
              >
                <div class="chat-header font-weight-bold mb-2" style="flex: 0 0 auto;">
                  {{ selectedChat ? selectedChat.ParticipantName : 'Выберите пользователя для начала общения' }}
                </div>

                <v-divider style="flex: 0 0 auto;"></v-divider>

                <!-- Messages List (Scrollable) -->
                <div
                    class="flex-grow-1 overflow-y-auto mt-2 mb-3 pr-2"
                    style="min-height: 0;"
                >
                  <div
                      v-for="(msg, index) in messages.messages"
                      :key="index"
                      class="d-flex flex-column"
                      :class="msg.SentById === $store.getters.appLogin.id ? 'align-items-end' : 'align-items-start'"
                      style="max-width: 70%;"
                  >
                    <v-chip
                        :color="msg.SentById === $store.getters.appLogin.id ? 'blue lighten-4' : 'grey lighten-3'"
                        class="ma-1"
                        label
                        small
                    >
                      {{ msg.Message }}
                    </v-chip>

                    <small class="text--secondary" style="font-size: 10px; margin-top: 2px;">
                      {{ formatDate(msg.SentOn) }}
                    </small>
                  </div>

                </div>

                <!-- Input -->
                <v-text-field
                    v-model="newMessage"
                    @keyup.enter="sendMessage"
                    :disabled="!selectedChat"
                    label="Введите сообщение"
                    placeholder="Напишите что-нибудь..."
                    dense
                    outlined
                    append-icon="mdi-send"
                    @click:append="sendMessage"
                    style="flex: 0 0 auto;"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showAddChatDialog" max-width="400px">
        <v-card>
          <v-card-title>Начать новый чат</v-card-title>
          <v-card-text>
            <v-autocomplete v-model="newChatUser"
                :items="accounts"
                :clearable="true"
                item-text="Name"
                item-value="Id"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showAddChatDialog = false">Отмена</v-btn>
            <v-btn color="primary" @click="startNewChat">Начать</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn class="white blue--text" small :to="{name: 'dashboard'}">На главную</v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view v-if="$store.getters.appIsInitialized"/>
      </v-container>
    </v-main>

    <v-overlay :value="$store.getters.layoutIsLoading || !$store.getters.appIsInitialized">
      <v-progress-circular class="d-block" indeterminate size="64"></v-progress-circular>
      <v-btn style="margin: 10px 0 0 -30px" @click="onCancelClicked">Отменить</v-btn>
    </v-overlay>

    <v-snackbar v-model="isSearchFailed"
                :timeout="5000"
                :top="true"
                color="error"
                class="text-center"
    >
      Ничего не найдно
    </v-snackbar>
  </v-app>
</template>

<script>
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";
import {APP_INITIALIZE_FAILED} from "@/events/app";
import SearchService from "@/services/search.service"
import MailService from "@/services/mail.service";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import AccountService from "@/services/account.service";
import AreaService from "@/services/area.service";
import AuthService from "@/services/auth.service";
import PostIndexService from "@/services/post.index.service";
import postPackageService from "@/services/post.package.service";
import printPackageService from "@/services/print.package.service";
import regionService from "@/services/region.service";
import UnitService from "@/services/unit.service";
import ReportService from "@/services/report.service";
import NotificationService from "@/services/notification.service";
import {AllowSendNotifications} from "@/enums/permission";
import _ from "underscore";

export default {
  name: "MainLayout",
  data: () => ({
    accounts: [],
    accountSearch: '',
    search: null,
    showAddChatDialog: false,
    newChatUser: null,
    isSearchFailed: false,

    users: [
      { id: 1, name: "Али", isunreaded: true },
      { id: 2, name: "Комрон", isunreaded: false },
      { id: 3, name: "Азиз", isunreaded: false },
      { id: 4, name: "Азиз", isunreaded: false },
      { id: 5, name: "Азиз", isunreaded: false },
      { id: 6, name: "Азиз", isunreaded: false },
      { id: 7, name: "Азиз", isunreaded: false },
      { id: 8, name: "Азиз", isunreaded: false },
      { id: 8, name: "Азиз", isunreaded: false },
      { id: 9, name: "Азиз", isunreaded: false },
    ],
    selectedChat: null,
    newMessage: "",

    chats: [],
    messages: [],
    showNotificationDialog: false,
  }),
  methods: {
    filter() {
      return (item, search, textKey) => {
        return item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1
      }
    },
    async NewChat(){
      this.showAddChatDialog = true;
      await this.loadAccounts()
    },
    async startNewChat() {
      await NotificationService.postMessage({
        ReceiverId: this.newChatUser,
        Message: "Chat boshlandi...".trim(),
      });

      await this.fetchChats();
      this.newChatUser = null;
      this.showAddChatDialog = false;
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
      const year = d.getFullYear();

      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    async init() {
      await this.fetchChats();

      // Auto-update chats every 30 seconds
      this.chatInterval = setInterval(() => {
        this.fetchChats();
      }, 10000); // 30,000 milliseconds = 30 seconds

      this.$bus.$on(APP_INITIALIZE_FAILED, this.onAppInitializationFailed);
    },
    async selectUser(item) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.selectedChat = item;

      await NotificationService.get(item.ParticipantId)
          .then(response => {
            this.messages = response.data
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })

      // Now fetch notifications
      await this.fetchChats();
    },
    async sendMessage() {
      if (!this.newMessage.trim()) return;

      await NotificationService.postMessage({
        ReceiverId: this.selectedChat.ParticipantId,
        Message: this.newMessage.trim(),
      });

      this.newMessage = "";

      await this.selectUser(this.selectedChat);
    },
    loadAccounts() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      NotificationService.getAccounts()
          .then(response => {
            this.accounts = response.data
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    onCreateNotificationClicked() {
      // this.loadAccounts();
      this.showNotificationDialog = true;
    },
    async fetchChats() {
      try {
        const response = await NotificationService.getAll();
        this.chats = response.data;
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    },
    onCancelClicked() {
      AccountService.cancelRequests();
      AreaService.cancelRequests();
      AuthService.cancelRequests();
      MailService.cancelRequests();
      PostIndexService.cancelRequests();
      postPackageService.cancelRequests();
      printPackageService.cancelRequests();
      regionService.cancelRequests();
      SearchService.cancelRequests();
      UnitService.cancelRequests();
      ReportService.cancelRequests();
      this.$store.dispatch(LAYOUT_LOADING_STOP)
    },
    onLogoutClicked() {
      this.$store.dispatch(AUTH_LOGOUT)
    },
    onAppInitializationFailed() {
      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({name: "login"})
    },
    onSearchKeyupEnter() {
      SearchService.get(this.search)
          .then(response => {
            switch (response.data.Type) {
              case "mail":
                this.$router.push({name: "mail", params: {uid: response.data.Uid}})
                break;

              case "print-package":
                this.$router.push({name: "print-package", params: {uid: response.data.Uid}})
                break;

              case "post-package":
                this.$router.push({name: "post-package", params: {uid: response.data.Uid}})
                break;

              case "post-package-group":
                this.$router.push({name: "post-package-group", params: {uid: response.data.Uid}})
                break;
            }

            this.search = null
          })
          .catch(() => {
            this.isSearchFailed = true;
          })
    }
  },
  computed: {
    filteredMessages() {
      if (!this.messages.messages) return [];
      // Adjust to the right user id property depending on selectedChat structure
      const userId = this.messages.user ? this.messages.user.Id : this.messages.id;
      return this.messages.messages.filter(msg => msg.SentById === userId);
    },
    AllowSendNotifications() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowSendNotifications
      })
    },
    notificationCount() {
      return this.chats.filter(user => user.IsUnread).length;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.$bus.$off(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
  }
}
</script>

<style scoped>
@media print {
  @page {
    size: a4 landscape;
    margin: 0;
    width: 100%;
  }

  main {
    padding: 0 !important;
  }

  body {
    padding: 0;
    margin: 0;
  }

  html, body {
    height: 210mm;
    width: 297mm;
  }

  div.container {
    padding: 0;
    margin: 0;
  }

  tr, th, td {
    padding: 0 !important;
    word-break: break-all !important;
  }

  table {
    overflow: hidden;
  }
  .v-list {
    padding: 0;
  }

  .v-list-item {
    cursor: pointer;
  }

}
</style>